// extracted by mini-css-extract-plugin
export default {"mainWrapper":"styles_mainWrapper__t0IMc","textWrapper":"styles_textWrapper__pUKd5","text":"styles_text__ar69o"};